import React, { useState } from "react";
import Row from "react-bootstrap/Row";
import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import { StyledCard } from "./styled";
import { getColor, getColorPais, getBandera } from "../../utils/formatter";
import { IoMdArrowDropdown, IoMdArrowDropright } from "react-icons/io";
import { FaArrowRight } from "react-icons/fa";
import { BsArrowUpRight, BsLink, BsFillStarFill } from "react-icons/bs";
import { MdStarBorder } from "react-icons/md";
import { CopyToClipboard } from "react-copy-to-clipboard";

function Cards(props) {
  const [openUno, setOpenUno] = useState(false);
    const [copied, setCopied] = useState(false);
  const { url, nombre, verificado, ID, categoria, descripcion, favicon_url } =
    props;



  const copyAnswer = (items, v) => {
    const textArea = document.getElementById("pruebaurl");
    textArea.value = items.resolution[0].url;

    }

  return (
    <>
      <StyledCard>
        {verificado == 0 ? (
          <Row>
            <Col lg={12} style={{ padding: "0px" }}>
              <div className="star">
                <MdStarBorder
                  style={{ fontSize: "25px", background: "yellow" }}
                />
              </div>
            </Col>
          </Row>
        ) : (
          <Row>
            <Col lg={12} style={{ padding: "0px" }}>
              <div className="star" style={{ color: "#f4f2f2" }}>
                SIN{" "}
              </div>
            </Col>
          </Row>
        )}

        <Row>
          <Col lg={12}>
            <p className="name">{nombre}</p>
          </Col>
        </Row>
        <Row>
          <Col lg={12} style={{ marginBottom: "10px", textAlign: "center" }}>
            <button className="categoria" style={{ background: "#003087" }}>
              {categoria}
            </button>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <p className="descripcion">{descripcion}</p>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <p className="icono">
              <img src={favicon_url} />
            </p>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <p className="organizacion">
              <a href={url} target="_blank">
                <button>
                  Ir a la herramienta{" "}
                  <BsArrowUpRight
                    style={{ fontSize: "15px", verticalAlign: "bottom" }}
                  />
                </button>
              </a>
            </p>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <p className="organizacion-compartir">
              <CopyToClipboard text={url} onCopy={() => setCopied(true)}>
                <button>
                  <BsLink
                    style={{
                      fontSize: "15px",
                      verticalAlign: "bottom",
                      marginRight: "8px",
                    }}
                  />
                  Compartir link
                </button>
              </CopyToClipboard>
            </p>
          </Col>
        </Row>
      </StyledCard>
      {/* <StyledCard>
        <Row>
          <Col lg={12}>
            <p className="fecha">{fecha}</p>
          </Col>
        </Row>
        <hr className="line-1" />
        <Row>
          <Col lg={12}>
            <p className="titulo">{titulo}</p>
          </Col>
        </Row>
        <Row>
          <Col lg={12} style={{ marginBottom: "10px" }}>
            <button
              className="calificacion"
              style={{ background: getColor(calificacion) }}
            >
              {calificacion}
            </button>
            <button
              className={
                pais == "Brasil" || pais == "Venezuela" || pais == "Colombia"
                  ? "pais-black"
                  : "pais-white"
              }
              style={{ background: getColorPais(pais) }}
            >
              <span
                role="img"
                aria-label="uk_flag"
                style={{
                  paddingRight: "7px",
                  verticalAlign: "text-bottom",
                }}
              >
                <img src={getBandera(pais)} width="16" height="12" />
              </span>
              {pais}
            </button>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <button className="vacunas">{tipo}</button>
          </Col>
        </Row>
        <hr className="line-2" />
        <Row>
          <Col lg={12}>
            <p className="descripcion">{descripcion}</p>
          </Col>
        </Row>
        <hr className="line-2" />
        <Row>
          <Col lg={12}>
            <p className="organizacion">
              Organizacion: <button>{organizacion}</button>
            </p>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <Accordion>
              <Card>
                <Accordion.Toggle
                  as={Card.Header}
                  eventKey="0"
                  onClick={() => setOpenUno(!openUno)}
                >
                  {openUno ? (
                    <>
                      <IoMdArrowDropdown size={25} />
                      <p>Ver menos información</p>
                    </>
                  ) : (
                    <>
                      <IoMdArrowDropright size={25} />
                      <p>Ver más información</p>
                    </>
                  )}{" "}
                </Accordion.Toggle>
                <Accordion.Collapse eventKey="0">
                  <Card.Body>
                    <p className="detalle">
                      Formato de la desinformación <br />
                      <span> {formato}</span>
                    </p>
                    <p className="detalle">
                      Tipo de nota <br />
                      <span> {explicador}</span>
                    </p>
                    <p className="detalle">
                      Link a desinformación <br />{" "}
                      <span>
                        <a href={linkImagen} target="_blank">
                          {linkImagen}
                        </a>
                      </span>
                    </p>
                    <p className="detalle">
                      Red social <br /> <span>{origen}</span>
                    </p>
                    <p className="detalle">
                      Persona <br /> <span>{personaOrigen}</span>
                    </p>
                    {otrospaises.length > 1 ? (
                      <p className="detalle">
                        País donde circuló <br /> <span>{otrospaises}</span>
                      </p>
                    ) : null}
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
            </Accordion>
          </Col>
        </Row>
        <Row>
          <Col lg={12} className="btn-ir">
            <Row>
              <Col sm={10} md={10} lg={10} style={{ paddingRight: "0px" }}>
                <button>
                  <a href={link} target="_blank">
                    Link al chequeo
                  </a>
                </button>
              </Col>
              <Col sm={2} md={2} lg={2} style={{ paddingLeft: "0px" }}>
                <div className="irlink">
                  <a href={link} target="_blank">
                    <FaArrowRight size={14} />
                  </a>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </StyledCard> */}
    </>
  );
}

export default Cards;
